import { createNullableProvideInject } from '@collector/shared-ui'

import { EventRelatedStatusConfig } from '../configuration'

export const [provideEventRelatedStatusConfig, injectEventRelatedStatusConfig] =
  createNullableProvideInject<EventRelatedStatusConfig>(
    'eventRelatedStatusConfig',
  )
